/**
 * Country name mappings for acronyms
 * Maps country acronyms to their full display names
 */
export const COUNTRY_NAMES: Record<string, string> = {
  USA: "United States",
  CAN: "Canada",
  MEX: "Mexico",
  ARE: "United Arab Emirates",
  ARG: "Argentina",
  AUS: "Australia",
  AUT: "Austria",
  BEL: "Belgium",
  BGD: "Bangladesh",
  BRA: "Brazil",
  CHE: "Switzerland",
  CHL: "Chile",
  CHN: "China",
  COL: "Colombia",
  CRI: "Costa Rica",
  CZE: "Czech Republic",
  DEU: "Germany",
  DNK: "Denmark",
  DOM: "Dominican Republic",
  EGY: "Egypt",
  ESP: "Spain",
  EUR: "European Union",
  FIN: "Finland",
  FJI: "Fiji",
  FRA: "France",
  GBR: "United Kingdom",
  GRC: "Greece",
  GTM: "Guatemala",
  HKG: "Hong Kong",
  HUN: "Hungary",
  IDN: "Indonesia",
  IND: "India",
  IRL: "Ireland",
  ISL: "Iceland",
  ISR: "Israel",
  ITA: "Italy",
  JPN: "Japan",
  KEN: "Kenya",
  KOR: "South Korea",
  LTU: "Lithuania",
  LUX: "Luxembourg",
  MAR: "Morocco",
  MYS: "Malaysia",
  NCL: "New Caledonia",
  NLD: "Netherlands",
  NGA: "Nigeria",
  NOR: "Norway",
  NZ: "New Zealand",
  NZL: "New Zealand",
  PAK: "Pakistan",
  PER: "Peru",
  PHL: "Philippines",
  PNG: "Papua New Guinea",
  POL: "Poland",
  PRT: "Portugal",
  ROU: "Romania",
  RUS: "Russia",
  SAU: "Saudi Arabia",
  SER: "Serbia",
  SGP: "Singapore",
  SVK: "Slovakia",
  SVN: "Slovenia",
  SWE: "Sweden",
  THA: "Thailand",
  TUR: "Turkey",
  TWN: "Taiwan",
  UKR: "Ukraine",
  URY: "Uruguay",
  UZB: "Uzbekistan",
  VEN: "Venezuela",
  VNM: "Vietnam",
  ZAF: "South Africa",
};

export const CANADA_PROVINCES: Record<string, string> = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  NT: "Northwest Territories",
  NU: "Nunavut",
  YT: "Yukon",
  FED: "Federal", // For federal level laws in Canada
};

export const MEXICO_STATES: Record<string, string> = {
  AG: "Aguascalientes",
  BN: "Baja California",
  BS: "Baja California Sur",
  CDM: "Ciudad de México",
  CS: "Chiapas",
  CH: "Coahuila",
  CI: "Chihuahua",
  CDMX: "Ciudad De Mexico",
  DG: "Durango",
  EM: "México",
  GJ: "Guanajuato",
  GE: "Guerrero",
  JA: "Jalisco",
  NL: "Nuevo León",
  QE: "Querétaro",
  SI: "Sinaloa",
  SL: "San Luis Potosí",
  SO: "Sonora",
  TB: "Tabasco",
  TA: "Tamaulipas",
  ZA: "Zacatecas",
  FED: "Federal", // For federal level laws in Mexico
};
/**
 * Gets the full country name for a given acronym
 * @param acronym - The country acronym (e.g., "USA", "CAN")
 * @returns The full country name or the original acronym if not found
 */
export function getDisplayCountryName(acronym: string): string {
  return COUNTRY_NAMES[acronym] ?? acronym;
}

export function getCanadaProvinceName(province: string): string {
  return CANADA_PROVINCES[province] ?? province;
}

export function getMexicoStateName(state: string): string {
  return MEXICO_STATES[state] ?? state;
}
